module.exports = __webpack_public_path__ + "static/media/tavuk2.42e4f38d.png";